export default function initPasswordInput() {
    const togglePassword = document.querySelector('#togglePassword');
    const password = document.querySelector('#Password');

    if (togglePassword && password) {
        togglePassword.addEventListener('click', function (e) {
            if (password.getAttribute('type') === 'password') {
                password.setAttribute('type', 'text');
                this.setAttribute('class', 'mdi mdi-eye');
            } else {
                password.setAttribute('type', 'password');
                this.setAttribute('class', 'mdi mdi-eye-off');
            }
        });
    }
}